import { useState, useEffect } from "react";
import "./TrainingTimes.css";

export default function TrainingTimes() {
  const [trainingData, setTrainingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrainingTimes = async () => {
      try {
        const response = await fetch("/data/trainingTimes.json");
        if (!response.ok) throw new Error("Fehler beim Laden der Trainingszeiten");
        const data = await response.json();
        setTrainingData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTrainingTimes();
  }, []);

  if (loading) return <section className="training-block"><p>Trainingszeiten laden...</p></section>;
  if (error) return <section className="training-block"><p>Fehler: {error}</p></section>;
  if (!trainingData) return null;

  const currentSessions =
    trainingData.homePageSessions[trainingData.activeSeason];

  return (
    <section className="training-block">
      <h3 className="training-title">Trainingszeiten</h3>
      <div className="training-container">
        {currentSessions.map((training) => (
          <article key={training.id} className="training-item">
            <p className="training-day">{training.day}</p>
            <p className="training-location">{training.location}</p>
            <p className="training-address">{training.address}</p>
            <p className="training-facility">{training.facility}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
